<template>
  <div id="app">
    <v-app>
      <router-view> </router-view>
      <v-snackbar
        v-model="snackbarShow"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        button
      >
        {{ snackbar.text }}

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbarShow = false"
            >Fechar</v-btn
          >
        </template>
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "app",
  computed: {
    snackbar() {
      return this.$store.state.ui.snackbar;
    },
    snackbarShow: {
      get() {
        return this.$store.state.ui.snackbar.show;
      },
      set(val) {
        if (!val) this.$store.dispatch("ui/hideSnackbar");
      },
    },
  },
};
</script>
